const { href } = window.location
let configs
if (href.indexOf('qa.give543.com') !== -1) {
  configs = {
    server: '//qa-api.give543.com',
    reqlApi: '/api',
    facebookAppID: '281409512031484',
    googleClientID: '102978352106-mipjlpsqq3rvd4068c8ncpbfc60kj0tg.apps.googleusercontent.com',
    frontEndUrl: 'https://qa.give543.com/',
    mobileUrl: 'https://m.qa.give543.com',
    host: '//qa-api.give543.com',
    queryShipFami: 'https://www.famiport.com.tw/Web_Famiport/page/ShopQuery.aspx',
    queryFamiProcess: 'https://www.famiport.com.tw/Web_Famiport/page/process.aspx',
    payNowUrl: 'https://test.paynow.com.tw/service/etopm.aspx',
    momoSearchUrl: 'https://m.momoshop.com.tw/search.momo',
    queryIBox: 'https://ipickup.post.gov.tw/E_MAP/Index'
  }
} else if (href.indexOf('give-circle.com') !== -1) {
  configs = {
    server: '//api.give543.com',
    reqlApi: '/api',
    facebookAppID: '281409512031484',
    googleClientID: '102978352106-mipjlpsqq3rvd4068c8ncpbfc60kj0tg.apps.googleusercontent.com',
    host: '//api.give543.com',
    frontEndUrl: 'https://www.give-circle.com/',
    mobileUrl: 'https://m.give543.com',
    queryShipFami: 'https://www.famiport.com.tw/Web_Famiport/page/ShopQuery.aspx',
    queryFamiProcess: 'https://www.famiport.com.tw/Web_Famiport/page/process.aspx',
    payNowUrl: 'https://www.paynow.com.tw/service/etopm.aspx',
    momoSearchUrl: 'https://m.momoshop.com.tw/search.momo',
    queryIBox: 'https://ipickup.post.gov.tw/E_MAP/Index'
  }
} else if (href.indexOf('give543.com') !== -1) {
  configs = {
    server: '//api.give543.com',
    reqlApi: '/api',
    facebookAppID: '281409512031484',
    googleClientID: '102978352106-mipjlpsqq3rvd4068c8ncpbfc60kj0tg.apps.googleusercontent.com',
    host: '//api.give543.com',
    frontEndUrl: 'https://www.give543.com/',
    mobileUrl: 'https://m.give543.com',
    queryShipFami: 'https://www.famiport.com.tw/Web_Famiport/page/ShopQuery.aspx',
    queryFamiProcess: 'https://www.famiport.com.tw/Web_Famiport/page/process.aspx',
    payNowUrl: 'https://www.paynow.com.tw/service/etopm.aspx',
    momoSearchUrl: 'https://m.momoshop.com.tw/search.momo',
    queryIBox: 'https://ipickup.post.gov.tw/E_MAP/Index'
  }
} else {
  configs = {
    server: 'https://qa-api.give543.com',
    reqlApi: '/api',
    facebookAppID: '281409512031484',
    googleClientID: '102978352106-mipjlpsqq3rvd4068c8ncpbfc60kj0tg.apps.googleusercontent.com',
    frontEndUrl: 'https://qa.give543.com/',
    mobileUrl: 'https://m.qa.give543.com',
    host: '//qa-api.give543.com',
    queryShipFami: 'https://www.famiport.com.tw/Web_Famiport/page/ShopQuery.aspx',
    queryFamiProcess: 'https://www.famiport.com.tw/Web_Famiport/page/process.aspx',
    payNowUrl: 'https://test.paynow.com.tw/service/etopm.aspx',
    momoSearchUrl: 'https://m.momoshop.com.tw/search.momo',
    queryIBox: 'https://ipickup.post.gov.tw/E_MAP/Index'
  }
}

export default configs
